import PolicyPage, { P, Section } from "@/components/PolicyPage";

export default function Privacy() {
  return (
    <PolicyPage eyebrow="Legal" title="Privacy Policy" testid="privacy-page"
      intro="Last updated: June 2026. This policy describes how SYNC (Atlanta, Georgia, USA) collects and uses your information when you use this website.">
      <Section title="Information we collect">
        <P>Order information: your name, email address, shipping address, and the items you purchase — used to produce, ship, and support your order.</P>
        <P>Account information: if you create an account, we store your name, email and an encrypted password.</P>
        <P>Payment information: payments are processed by Stripe. SYNC never receives or stores your card number.</P>
        <P>Usage information: anonymized page-view data (a random visitor ID, pages visited and referrer) to understand how the store is used.</P>
      </Section>

      <Section title="How we use your information">
        <P>To fulfill orders, send order confirmations and shipping/tracking updates, respond to support requests, and — only if you signed up for it — send launch or promotional emails.</P>
        <P>We do not sell your personal information.</P>
      </Section>

      <Section title="Cookies & local storage">
        <P>We use browser local storage for your cart, login session, chat assistant session, and a random visitor ID for analytics. Stripe may set cookies during checkout as described in Stripe's own privacy policy.</P>
      </Section>

      <Section title="Sharing">
        <P>We share data only with service providers needed to run the store: Stripe (payments), our production/fulfillment partner (name and shipping address only), shipping carriers, and our email provider for transactional messages.</P>
      </Section>

      <Section title="Your rights">
        <P>You may request access to, correction of, or deletion of your personal data by emailing <a href="mailto:info@thesyncwear.com" className="text-signal hover:underline">info@thesyncwear.com</a>.</P>
      </Section>

      <Section title="Contact">
        <P>SYNC — Atlanta, Georgia, USA · <a href="mailto:info@thesyncwear.com" className="text-signal hover:underline">info@thesyncwear.com</a></P>
      </Section>
    </PolicyPage>
  );
}
